/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取剧院底部信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.FooterArticlesDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater-footers`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
